/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Create_DescriptionInputs */



/**
* | output |
* | --- |
* | "Define compliance rules to audit or block sensitive requests." |
*
* @param {Compliance_Template_Create_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_create_description = /** @type {((inputs?: Compliance_Template_Create_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Create_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Definieren Sie Compliance-Regeln zum Prüfen oder Blockieren sensibler Anfragen.")
	return /** @type {LocalizedString} */ ("Define compliance rules to audit or block sensitive requests.")
});